import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'rgpd',
  templateUrl: './rgpd.component.html',
  styleUrls: ['./rgpd.component.scss']
})
export class RgpdComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
